<template>
    <!--解决弹窗-->
    <el-dialog 
      title="解决 (状态修改为已解决 并指派给创建人)" 
      :visible.sync="dialogVisibleSolve" 
      width="60%" 
      :before-close="handleCloseSolve" 
      :close-on-press-escape="false" 
      :close-on-click-modal="false">
      <el-form 
        :model="solve" 
        ref="solve" 
        :inline="true" 
        label-width="80px">
        <el-form-item label="回复工单" class="solve_summernote_item">
          <EditorSummernote ref="summernote_3" v-model="solve.content" id="solve_summernote"/>

          <TicketUploadList ref = "upList2"
            @clear="() => { this.$refs.up5.clearFile(); }"
            @delete="(e) => { this.$refs.up5.deleteFile(e); }"/>

          <TicketUpload ref="up5" :ticketUploadList="$refs.upList2"/>

          <TicketTemplateSelect @selected="onTicketTemplateSelected"/>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseSolve">取消</el-button>
        <SubmitTicketButton @click="solveOrder" buttonText="提交" ref="solveBtn_1"/>
      </span>
    </el-dialog>
</template>

<script>
export default {
  name: "TicketSolveDialog",

  props : ["ticketNo"],

  data() {
    return {
      dialogVisibleSolve: false,
      solve: {
        content: '',
        orderNoticeList: [] //通知列表
      },
    };
  },

  methods: {
    show() {
        this.dialogVisibleSolve=true;
    },

    onTicketTemplateSelected(ticketTemplate) {
      if ( !ticketTemplate || !ticketTemplate.content ) {
        console.log("#55 ticketTemplate is empty", ticketTemplate);
        _message("模板为空");
        return;
      }

      var _editorContent = this.$refs.summernote_3.summernoteGetCode();
      var _newContent = "";
      if ( !!_editorContent ) {
        _newContent += _editorContent + "<br/><br/>";
      }

      _newContent += ticketTemplate.content;

      this.$refs.summernote_3.summernoteSetCode( _newContent );
    },

    //解决
    solveOrder() {
      var _this = this;

      this.$refs.solve.validate(valid => {
        if ( !valid ) {
          return false
        }

        _this.$refs.solveBtn_1.disable();

        var data = {
          'orderId': _this.ticketNo,
          'orderRemark.remarkContent': _this.solve.content
        }

        data.attachmentList = _this.$refs.up5.getAttachmentList();

        _this.$http.post('/ticket/v2-workOrder/solve', data).then(response => {
          _this.$refs.solveBtn_1.enable();

          var result = response.data;
          if(result.status) {
            _message('解决工单成功');

            _this.handleCloseSolve();

            _this.$refs.up5.setFileList([]);
            _this.$emit('change', null);
          } else {
            if ( !!result.message ) {
              _this.$alert(result.message);
            } else {
              _this.$alert("工单系统后台错误 #489");
            }
          }
        }, response => {
          _this.$refs.solveBtn_1.enable();

          _this.$alert('网络繁忙，请稍后重试 #493')
        });
      })
    },

    //弹出层关闭-解决
    handleCloseSolve() {
      this.$refs['solve'].resetFields();
      this.dialogVisibleSolve = false;
    }
  }
};
</script>

<style>
  .solve_summernote_item .note-editor.note-frame {
    width: calc(60vw - 120px);
  }

  .solve_summernote_item {
    padding-bottom: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketSolveDialog.vue